<div>
	<div *ngIf="showThanksMessage()" class="label-text-box">
		{{getData().submitThanksMessage}}
	</div>
	<div *ngIf="showThanksMessage2()" class="label-text-box">
		{{getData().submitThanksMessage2}}
	</div>
	<div *ngIf="!showFeedback()" class="label-text-box">
		<span>
			{{getData().submitRequestLabel}}:
		</span>
		<span class="snackbar-font-size">
			{{getData().submitrequestId}}
		</span>
	</div>
	<div *ngIf="!showFeedback()" class="label-text-box">
		{{getData().submitRequestFeedback}}
	</div>
	<div *ngIf="getOrderConfirmationMsg() !== ''">
		<span>
			{{ getOrderConfirmationMsg() }}
		</span>
	</div>
	<div *ngIf="showRedirectLink()" class="follow-up-content">
		<span class="follow-up-text">
			{{ getData().followUpText }}
		</span>
		<a class="follow-up-link" (click)="$event.preventDefault();navigateToFollowUpView()" href="#">
			<span> {{ getData().followUpLink }}</span>
		</a>
	</div>

	<div class="snackbar-close-align-right">
		<button type="submit" mat-button class="button-link-margin" (click)="dismiss()">
			<span translate>ok.value</span>
		</button>
	</div>

</div>